export enum MainContentViews {
    NewsfeedResults = 1,
    SearchResults = 2,
}
